import qs from 'qs';
import { useSearchParams } from 'react-router-dom';

// Custom hook that fetches the search term from the query params of the page's URL
export const useSearchTerm = (): (string | undefined) => {
  const [qParams] = useSearchParams();
  const queryObj = qs.parse(qParams.toString());

  return queryObj?.search?.toString();
};

